export default __webpack_public_path__ + "static/media/certificate_2.425af329.jpg";